<template>
  <div class="col-12 col-lg-3 d-flex d-lg-block mt-4 mt-lg-0">

    <div class="sidebar sidebar-content sidebar-right mb-4 ms-auto">
      <h2>Lamp kleur</h2>
      <p>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="green" class="bi bi-circle-fill" viewBox="0 0 16 16">
          <circle cx="8" cy="8" r="8"/>
        </svg>
        Gewonnen
      </p>
      <p>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="yellow" class="bi bi-circle-fill" viewBox="0 0 16 16">
          <circle cx="8" cy="8" r="8"/>
        </svg>
        Buiten de range
      </p>
      <p>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" class="bi bi-circle-fill" viewBox="0 0 16 16">
          <circle cx="8" cy="8" r="8"/>
        </svg>
        Maximaal aantal items
      </p>
      <p>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#b6cdb3" class="bi bi-circle-fill" viewBox="0 0 16 16">
          <circle cx="8" cy="8" r="8"/>
        </svg>
        Niet gewonnen
      </p>
    </div>

    <div class="sidebar sidebar-content sidebar-right mb-4 ms-lg-auto">
      <h2 class="price__range display-3"> Prijsrange </h2>
      <p class=""> {{ item.range_min }} - {{ item.range_max }} </p>
    </div>

     <div class="sidebar sidebar-content sidebar-right mb-4 ms-auto" v-if="item.purchased_by[0]">
      <h2 class="display-3 mb-0"> Winnaar
        <div class="text-uppercase mb-5">{{ item.purchased_by[0].name }}</div>
      </h2>

      <div class="d-flex d-lg-block">
        <div class="bid me-5 me-lg-0">
          <p class="option__name">Geboden</p>
          <p class="price mb-5"> &euro; {{ formatNumber(item.purchased_by[0].pivot.price) }} </p>
        </div>

        <div class="name">
          <p class="option__name">Totaal kosten</p>
          <p class="price">&euro; {{ formatNumber(item.purchased_by[0].pivot.price * item.units_per_pack) }} </p>
        </div>
      </div>

    </div>

    <div class="sidebar sidebar-content sidebar-right mb-4 ms-auto" v-if="!item.purchased_by[0]">
      <h2 class="display-3"> Tips </h2>
      <ul>
        <li>Per getal op de klok &euro; {{ item.unit }}, maximaal 100 x &euro; {{ item.unit }} =  &euro; {{ getMaxPricePerUnit() }} per stuk </li>
        <li>Er wordt altijd per stuk geveild. </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    bidder: {
      type: Object,
      default: null,
    }

  },
  methods: {
    formatNumber(price)
    {
      if (price) {
        return price.toFixed(2);
      }
    },
    getMaxPricePerUnit()
    {
      return parseFloat(this.item.unit) * 100;
    }

  }
}
</script>
